const type = 'SET_CONFIRM_CANCEL_INVOICE_INSTALLMENT';

const setConfirmCancelInvoiceInstallment = () => ({
  type,
});

export { type };
export default setConfirmCancelInvoiceInstallment;
